import React from 'react';
import { Flex, Box, Heading } from 'theme-ui';
import Divider from '@solid-ui-components/Divider';
import ContentText from '@solid-ui-components/ContentText';
import Reveal from '@solid-ui-components/Reveal/Reveal';

const styles = {
  box: {
    position: `relative`,
    flexShrink: 0, mr: 4
  },
  listItem: {
    alignItems: `stretch`,
    justifyContent: `flex-start`,
  },
  line: {
    position: `absolute`,
    bottom: `10px`,
    left: `50%`,
    width: `1px`,
    height: t => `calc(100% - ${t.sizes.icon.md + 20}px)`,
    transform: `translateX(-50%)`,
    zIndex: 1,
    bg: `omega`,
  },
  number: {
    fontSize: '20px',
    fontWeight: 600,
    color: `white`,
    borderRadius: `15px`,
    bg: `#026aa2`,
    textAlign: `center`,
    alignContent: 'center',
    width: '40px',
    height: '40px'
  },
};

const DottedNumberedList = ({ collection }) => (
  <>
    <Divider space={3} />
    {collection.map(({ text }, index) => (
      <Reveal key={`reveal-${index}`} effect='fadeInUp'>
        <Flex sx={styles.listItem}>
          <Box sx={styles.box}>
            <Heading as="div" sx={styles.number}>
              {index + 1}
            </Heading>
            {index + 1 < collection.length && <Box sx={styles.line} />}
          </Box>
          <Box>
            <ContentText sx={{ pt: '5px' }} content={text} />
            {index + 1 < collection.length && <Divider space={5} />}
          </Box>
        </Flex>
      </Reveal>
    ))}
  </>
);

export default DottedNumberedList;
